import * as React from "react";

export const IconSocialShare = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_41279_6275)">
      <path
        d="M15 13.4003C14.3667 13.4003 13.8 13.6503 13.3667 14.042L7.425 10.5837C7.46667 10.392 7.5 10.2003 7.5 10.0003C7.5 9.80033 7.46667 9.60866 7.425 9.41699L13.3 5.99199C13.75 6.40866 14.3417 6.66699 15 6.66699C16.3833 6.66699 17.5 5.55033 17.5 4.16699C17.5 2.78366 16.3833 1.66699 15 1.66699C13.6167 1.66699 12.5 2.78366 12.5 4.16699C12.5 4.36699 12.5333 4.55866 12.575 4.75033L6.7 8.17533C6.25 7.75866 5.65833 7.50033 5 7.50033C3.61667 7.50033 2.5 8.61699 2.5 10.0003C2.5 11.3837 3.61667 12.5003 5 12.5003C5.65833 12.5003 6.25 12.242 6.7 11.8253L12.6333 15.292C12.5917 15.467 12.5667 15.6503 12.5667 15.8337C12.5667 17.1753 13.6583 18.267 15 18.267C16.3417 18.267 17.4333 17.1753 17.4333 15.8337C17.4333 14.492 16.3417 13.4003 15 13.4003Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_41279_6275">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
